import { render, staticRenderFns } from "./TheApplicationSidebarMenuItem.vue?vue&type=template&id=50828ca6&scoped=true&"
import script from "./TheApplicationSidebarMenuItem.vue?vue&type=script&lang=js&"
export * from "./TheApplicationSidebarMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./TheApplicationSidebarMenuItem.vue?vue&type=style&index=0&id=50828ca6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50828ca6",
  null
  
)

export default component.exports